module.exports = __webpack_public_path__ + "img/image-plus.eaaa067b.svg";